export default __webpack_public_path__ + "static/media/wallpaper_bg6.a384c8a2.png";